// Third-party
import Box from '@mui/material/Box';

// Components
import { useState } from 'react';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { InviteAddMemberNav, InviteTeamHeader, InviteTeamList } from '../../features/onboarding';
import { TLocation } from '../../types';
import { InviteTeamTour } from '../../features/onboarding/components/Tour';

type TInviteMember = {
  permissionLevel: number
  locations: Array<TLocation>
  firstName: string,
  lastName: string
  email: string
};

const InviteTeamPage = () => {
  const [isOpenInviteMember, setIsOpenInviteMember] = useState(false);
  const [mode, setMode] = useState('create');
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);
  const [runTour, setRunTour] = useState(false);

  const [formInputs, setFormInputs] = useState({
    locations: [{
      id: 1,
      name: 'Back Office',
    }],
    permissionLevel: 0,
    firstName: '',
    lastName: '',
    email: '',
  } as TInviteMember);

  const handleCloseNav = () => {
    setIsOpenInviteMember(false);
  };

  const handleStartTour = () => {
    setRunTour(true);
  };

  const handleOpenNav = () => {
    setIsOpenInviteMember(true);
  };

  return (
    <Box>
      <InviteTeamTour handleCloseNav={handleCloseNav} handleOpenNav={handleOpenNav} setRunTour={setRunTour} runTour={runTour} />
      <Box px={isMobile ? 2 : 4}>
        <InviteTeamHeader handleStartTour={handleStartTour} />
      </Box>
      <Box px={isMobile ? 0 : 4}>
        <InviteTeamList setFormInputs={setFormInputs} setMode={setMode} setIsOpenInviteMember={setIsOpenInviteMember} />
      </Box>
      <InviteAddMemberNav
        setFormInputs={setFormInputs}
        formInputs={formInputs}
        mode={mode}
        handleCloseNav={handleCloseNav}
        isOpenNav={isOpenInviteMember}
      />
    </Box>
  );
};

export default InviteTeamPage;
